import Http from 'axios'
import {
    VERSIONED_API_URL
} from '../../config/config'

function initialState() {
    return {
        offices: [],
        embassyOffices: [],
        query: '',
        filter: '',
        custom_offices: [],
    }
}

const getters = {
    offices: state => state.offices,
    embassyOffices: state => state.embassyOffices,
    loading: state => state.loading,
    serverPagination: state => state.serverPagination,
    filter: state => state.filter,
    query: state => state.query,
    role: state => state.role,
    totalNumber: state => state.totalNumber
}

const actions = {
    async fetchData({state, commit}, show_main = false) {
        let query = '';

        if (typeof state.filter.type !== 'undefined')
            query = `type=${state.filter.type}&`;

        if (state.filter.main_office !== undefined && show_main)
            query = `${query}main_office=true`;

        const response = await Http.get(`${VERSIONED_API_URL}/offices?${query}`);
        commit('setAll', response.data.data);
        return response.data.data;
    },
    async fetchAll({commit}) {

        const response = await Http.get(`${VERSIONED_API_URL}/offices/fetch-all`);
        commit('setAll', response.data);
        return response.data;
    },
    async fetchAllExceptGovernment({commit}) {

        const response = await Http.get(`${VERSIONED_API_URL}/offices/fetch-all?except=true`);
        commit('setAll', response.data);
        return response.data;
    },
    async fetchCustomData({state, commit}, types) {
        const response = await Http.get(`${VERSIONED_API_URL}/offices`, {
            params: {types}
        });
        commit('setAll', response.data.data);
        return response.data.data;
    },
    fetchEmbassyoffices({commit}) {
        Http.get(`${VERSIONED_API_URL}/embassy/offices`)
            .then(response => {
                commit('setEmbassyOffices', response.data);
            });
    },


    resetState({commit}) {
        commit('resetState')
    }
}

const mutations = {
    setAll(state, items) {
        state.offices = items
    },
    setEmbassyOffices(state, items) {
        state.embassyOffices = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setRole(state, role) {
        state.role = role
    },
    setQuery(state, query) {
        state.query = query
    },
    setFilter(state, item) {
        state.filter = item
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    },
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
